<template>
  <div>
    <v-row align="center" class="grey lighten-5">
      <v-col class="text-center" cols="12" sm="3">
        <div class="my-2">
          <router-link :to="'/js-beautify'">
            <v-btn small :outlined="jsBeautify" color="primary" rounded dark>JS Beautify</v-btn>
          </router-link>
        </div>
      </v-col>
      <v-col class="text-center" cols="12" sm="3">
        <div class="my-2">
          <router-link :to="'/css-beautify'">
            <v-btn small :outlined="cssBeautify" color="primary" rounded dark>CSS Beautify</v-btn>
          </router-link>
        </div>
      </v-col>
      <v-col class="text-center" cols="12" sm="3">
        <div class="my-2">
          <router-link :to="'/html-beautify'">
            <v-btn small :outlined="htmlBeautify" color="primary" rounded dark>HTML Beautify</v-btn>
          </router-link>
        </div>
      </v-col>
      <v-col class="text-center" cols="12" sm="3">
        <div class="my-2">
          <router-link :to="'/xml-beautify'">
            <v-btn small :outlined="xmlBeautify" color="primary" rounded dark>XML Beautify</v-btn>
          </router-link>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  export default {
    props:{
      jsBeautify:Boolean,
      cssBeautify:Boolean,
      htmlBeautify:Boolean,
      xmlBeautify:Boolean,
    }
  }
</script>